import React from 'react';
import { classes } from './PaymentDetails.st.css';
import Text, { TextType } from '../../Text/Text';
import { PaymentOption, PaymentType } from '../../../../types/types';
import { PaymentDetailsDataHooks } from './dataHooks';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { PriceUtils } from '@wix/bookings-uou-mappers';
import { useFormComponentContext } from '../../Hooks/useFormComponentContext';
import { Divider } from '@wix/wix-base-ui';

interface PaymentDetailsProps {
  paymentOption: PaymentOption;
  payNowAmount?: number;
  currency?: string;
}

export const PaymentDetails: React.FC<PaymentDetailsProps> = ({
  paymentOption,
  payNowAmount,
  currency,
}) => {
  const { label, suffix, validUntil } = paymentOption;
  const { t } = useTranslation();
  const { dateRegionalSettingsLocale } = useFormComponentContext();

  const showPayNow = !!(paymentOption.type === PaymentType.USE_PLAN && payNowAmount && payNowAmount > 0);

  return (
    <div data-hook={PaymentDetailsDataHooks.PAYMENT_DETAILS}>
      <div className={classes.paymentDetails}>
        <Text type={TextType.Secondary}>{label}</Text>
        {suffix ? (
          <Text className={classes.planSlotsLeft} type={TextType.Secondary}>
            {suffix}
          </Text>
        ) : null}
      </div>
      <div>
        <Text type={TextType.Secondary}>{validUntil}</Text>
      </div>
      {showPayNow && (
        <>
          <Divider className={classes.divider} />
          <div className={classes.payNowSection} data-hook={PaymentDetailsDataHooks.PAY_NOW_SECTION}>

            <div className={classes.payNowDetails}>
              <Text type={TextType.Secondary}>
                {t('app.payment.summary.pay-now.label')}
              </Text>
              <Text
                type={TextType.Secondary}
                data-hook={PaymentDetailsDataHooks.PAY_NOW_AMOUNT}
              >
                {PriceUtils.getFormattedCurrency({
                  price: payNowAmount,
                  currency: currency || 'USD',
                  locale: dateRegionalSettingsLocale,
                })}
              </Text>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
